import { render } from "./BinaryChoiceButton.vue?vue&type=template&id=31490bf0&scoped=true"
import script from "./BinaryChoiceButton.vue?vue&type=script&lang=js"
export * from "./BinaryChoiceButton.vue?vue&type=script&lang=js"

import "./BinaryChoiceButton.vue?vue&type=style&index=0&id=31490bf0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31490bf0"]])

export default __exports__